import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const HERO_SLIDES = [
  { category: "Wedding expos", src: "/images/wedding-expo.jpg", alt: "Couples browsing vendor booths at a wedding expo" },
  { category: "Home shows", src: "/images/home-show.jpg", alt: "Kitchen showroom booth at a home show" },
];

export function HeroCarousel({ slides = HERO_SLIDES, interval = 5000 }: { slides?: typeof HERO_SLIDES; interval?: number }) {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const go = (n: number) => setI((n + slides.length) % slides.length);

  useEffect(() => {
    if (paused || slides.length < 2) return;
    const t = setTimeout(() => go(i + 1), interval);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i, paused, interval, slides.length]);

  return (
    <div className="hard-shadow group relative h-[420px] w-full overflow-hidden rounded-sm border" onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)} data-testid="hero-carousel">
      {slides.map((s, idx) => (
        <img key={s.src} src={s.src} alt={s.alt} data-testid={`hero-slide-${idx}`}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${idx === i ? "opacity-100" : "opacity-0"}`} />
      ))}
      <span className="absolute left-4 top-4 rounded-sm bg-white/95 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-primary" data-testid="hero-slide-category">
        {slides[i].category}
      </span>
      {slides.length > 1 && (
        <>
          <button onClick={() => go(i - 1)} aria-label="Previous image" data-testid="hero-prev-button"
            className="absolute left-3 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-sm bg-white/90 opacity-0 transition-opacity group-hover:opacity-100">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button onClick={() => go(i + 1)} aria-label="Next image" data-testid="hero-next-button"
            className="absolute right-3 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-sm bg-white/90 opacity-0 transition-opacity group-hover:opacity-100">
            <ChevronRight className="h-5 w-5" />
          </button>
          <div className="absolute bottom-4 left-4 flex gap-2">
            {slides.map((s, idx) => (
              <button key={s.src} onClick={() => go(idx)} aria-label={`Show ${s.category}`} data-testid={`hero-dot-${idx}`}
                className={`h-1.5 rounded-sm transition-all ${idx === i ? "w-8 bg-primary" : "w-4 bg-white/80"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
